/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Just_ExploringInputs */



/**
* | output |
* | --- |
* | "Just exploring what's possible" |
*
* @param {Onboarding_Usage_Just_ExploringInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_just_exploring = /** @type {((inputs?: Onboarding_Usage_Just_ExploringInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Just_ExploringInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einfach erkunden, was möglich ist")
	return /** @type {LocalizedString} */ ("Just exploring what's possible")
});